import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-recommendation-folder.controller';
import directive from './attach-recommendation-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachRecommendationFolder', [
  alerts,
  amDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amAttachRecommendationFolder', directive)
  .controller('AttachRecommendationFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachRecommendationFolder created');
